import axios from "axios";
import { toast } from "react-toastify";
import useAuthStore from "store";

const loginPath = "/login";
export const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const instance = axios.create({
  baseURL: `${BASE_URL}/api/v1/`,
});

instance.interceptors.request.use(async (config) => {
  const accessTokenStore = useAuthStore.getState().accessTokenStore;
  const requiresAuth = config.requiresAuth ?? true;
  const formData = config.formData ?? false;

  config.headers["Content-Type"] = formData ? "multipart/form-data" : "application/json";
  config.headers["Accept-Language"] = "fa";

  if (requiresAuth && accessTokenStore) {
    config.headers.Authorization = `Token ${accessTokenStore}`;
  }

  return config;
});

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error?.response?.status === 401) {
      const storeLogout = useAuthStore.getState().storeLogout;
      storeLogout();
      toast.error("لطفا وارد شوید.");
      window.location.href = loginPath;
      return;
    }

    return Promise.reject(error);
  }
);

export default instance;
